import React from 'react';
import { connect } from 'react-redux';
import EnumSelectorBase from './EnumSelectorBase';

const EquipmentTypeSelector = ({
  equipTypes,
  equipSubTypes,
  value,
  setValue,
  sortOptions,
  renderOption,
}) => {
  const allTypes = Object.values(equipTypes).concat(Object.values(equipSubTypes));
  return (
    <EnumSelectorBase
      name="Equipment Type"
      options={Object.values(allTypes).sort(sortOptions)}
      getOptionLabel={(option) => option?.tagName || option}
      isOptionEqualToValue={(option, v) => option.tagName === v}
      value={value}
      onChange={(newValue) => setValue(newValue.tagName)}
      renderOption={renderOption}
    />
  );
};

export default connect(
  ({
    entities: {
      equipTypes: { byId: equipTypes },
      equipSubTypes: { byId: equipSubTypes },
    },
  }) => ({
    equipTypes,
    equipSubTypes,
  })
)(EquipmentTypeSelector);
